import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/wingman/7e1b41d7-cb47-4627-a363-d0e2bc80c154/attachments/355f24cbb44947998348bd262690697f_image.png";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Le mot de passe doit comporter au moins 6 caractères");
      return;
    }
    setLoading(true);
    const result = await register(email, password, name);
    setLoading(false);
    if (result.ok) {
      toast.success("Compte créé avec succès !");
      navigate("/");
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-12">
      <Card className="w-full max-w-md p-8 rounded-2xl border-brand-line bg-white shadow-[0_8px_32px_rgba(45,42,38,0.04)]">
        <Link to="/" className="flex items-center gap-2.5 mb-8">
          <img src={LOGO_URL} alt="Kanama" className="h-10 w-10 object-contain" />
          <span className="font-heading font-bold text-xl text-brand-ink">Kanama</span>
        </Link>
        <h1 className="font-heading text-2xl font-semibold text-brand-ink mb-2">
          Rejoignez la communauté
        </h1>
        <p className="text-sm text-brand-inkSoft mb-8">
          Créez votre compte pour découvrir et partager les meilleures adresses du Tchad.
        </p>
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="register-form">
          <div>
            <Label htmlFor="name" className="text-brand-ink">
              Nom complet
            </Label>
            <Input
              id="name"
              required
              autoComplete="name"
              enterKeyHint="next"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1.5 h-12 rounded-xl border-brand-line text-base"
              placeholder="Votre nom"
              data-testid="register-name"
            />
          </div>
          <div>
            <Label htmlFor="email" className="text-brand-ink">
              E-mail
            </Label>
            <Input
              id="email"
              type="email"
              required
              autoComplete="email"
              inputMode="email"
              enterKeyHint="next"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 h-12 rounded-xl border-brand-line text-base"
              placeholder="vous@exemple.td"
              data-testid="register-email"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-brand-ink">
              Mot de passe
            </Label>
            <Input
              id="password"
              type="password"
              required
              autoComplete="new-password"
              enterKeyHint="go"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 h-12 rounded-xl border-brand-line text-base"
              placeholder="Au moins 6 caractères"
              data-testid="register-password"
            />
          </div>
          {error && (
            <div className="text-sm text-destructive bg-red-50 border border-red-200 rounded-xl p-3" data-testid="register-error">
              {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-full bg-brand-terracotta hover:bg-brand-terracottaHover text-white font-semibold"
            data-testid="register-submit"
          >
            {loading ? "Création..." : "Créer mon compte"}
          </Button>
        </form>
        <p className="text-sm text-brand-inkSoft mt-6 text-center">
          Déjà un compte ?{" "}
          <Link to="/login" className="text-brand-terracotta font-semibold hover:underline">
            Se connecter
          </Link>
        </p>
      </Card>
    </div>
  );
}
